import React, {useContext} from "react";
import "./TechnologiesAndTools.scss";
import {technologiesSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function TechnologiesAndTools() {
  const {isDark} = useContext(StyleContext);
  if (!technologiesSection.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="technologies">
        <div className="technologies-main-div">
          <div className="technologies-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading technologies-heading"
                  : "heading technologies-heading"
              }
            >
              {technologiesSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle technologies-subtitle"
                  : "subTitle technologies-subtitle"
              }
            >
              {technologiesSection.subtitle}
            </p>
          </div>
          <div className="technologies-categories">
            {technologiesSection.categories.map((category, categoryIndex) => (
              <div
                key={categoryIndex}
                className="technologies-category"
              >
                <h3
                  className={
                    isDark
                      ? "dark-mode category-title"
                      : "category-title"
                  }
                >
                  {category.name}
                </h3>
                <div className="technologies-grid">
                  {category.technologies.map((tech, techIndex) => (
                    <div
                      key={techIndex}
                      className="technology-item"
                      title={tech.name}
                    >
                      <img
                        src={tech.icon}
                        alt={tech.name}
                        className="technology-icon"
                      />
                      <p
                        className={
                          isDark
                            ? "dark-mode technology-name"
                            : "technology-name"
                        }
                      >
                        {tech.name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
}
